/// <reference path="DOMAttached.js" />

class AwardScoops extends DOMAttached {
	constructor(el, options) {
		super(el, options);
		this.messageSelector = this.el.querySelector('.messageSelector');
		this.messageInput = this.el.querySelector('.messageInput').querySelector('input');
		this.safeObserve(this.messageSelector, 'change', this.onMessageSelected.bind(this));
	}

	onMessageSelected(ev) {
		if (this.messageSelector.selectedIndex != 0) {
			this.messageInput.value = this.messageSelector.options[this.messageSelector.selectedIndex].value;
			this.messageSelector.selectedIndex = 0;
		}
	}
}
